import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "viewing-card-title" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

import { computed, toRefs } from 'vue'
    import { isPast } from 'date-fns'
    import { formatDate } from '@/helpers/date'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as { date: Date }

    
    const { date } = toRefs(props)

    const dayLabel = computed(() => formatDate(date.value, 'EEEE').toUpperCase())
    const dateLabel = computed(() => formatDate(date.value, 'PPPp').toLowerCase())
    const colorClass = computed<string>(() => isPast(date.value) ? 'text-sky-400' : 'text-orange-400')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["title", _unref(colorClass)]),
      textContent: _toDisplayString(_unref(dayLabel))
    }, null, 10, _hoisted_2),
    _createElementVNode("div", {
      class: "sub",
      textContent: _toDisplayString(_unref(dateLabel))
    }, null, 8, _hoisted_3)
  ]))
}
}

})